import { Card, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";
import TableCard from "./TableCard";
import ApiService from "services/ApiService";
import Helpers from "utils/Helpers";

function OpenTablesCard({ companyId, branch, counter }) {
  const [tablesData, setTablesData] = useState([]);

  const fetchOpenTables = async () => {
    const response = await ApiService.getData(
      `/api/v1/open-tables/?companyId=${companyId}&branch=${branch}`
    );
    if (!response) return;

    const tableData = response.data.data.map((el) => {
      return {
        companyId: companyId,
        tableId: el.id,
        tableName: el.name,
        total: el.amountToPay,
        startDate: Helpers.formatDateToNormal(el.createdAt),
      };
    });
    setTablesData(tableData);
  };
  useEffect(() => {
    if (companyId === undefined || branch === undefined) return;
    fetchOpenTables();
  }, [companyId, branch, counter]);
  return (
    <SoftBox my={3}>
      <Card>
        <Grid container md={12} xs={12}>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Ανοιχτά τραπέζια
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular" color="text">
                Παρακάτω εμφανίζονται όλα τα ανοιχτά τραπέζια της επιλεγμένης επιχείρησης.
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </Grid>
        <Grid container xs={12}>
          {tablesData.map((table) => (
            <TableCard {...table} key={table.tableName} />
          ))}
        </Grid>
      </Card>
    </SoftBox>
  );
}

export default OpenTablesCard;
